// extracted by mini-css-extract-plugin
export default {"shell":"EducationCourseLayout_shell__ETrPt","courseTabs":"EducationCourseLayout_courseTabs__Yxhar"};